
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const ChimneyCleaningPage = () => {
  const faqs = [
    {
      question: 'Baca temizliği ne zaman yapılmalıdır?',
      answer: 'Baca temizliği yılda en az bir kez, tercihen ısınma sezonundan önce yapılmalıdır. Yoğun kullanılan bacalarda yılda iki kez temizlik önerilir.',
    },
    {
      question: 'Baca temizliği fiyatları nedir?',
      answer: 'Baca temizliği fiyatları, bacanın tipi, yüksekliği, kirliliği ve erişim zorluğuna göre değişiklik gösterir. Ücretsiz keşif sonrası net fiyat teklifi sunuyoruz.',
    },
    {
      question: 'Baca temizliği ne kadar sürer?',
      answer: 'Standart bir baca temizliği işlemi 1-2 saat arasında tamamlanır. Çok kirli veya uzun bacalarda süre uzayabilir.',
    },
    {
      question: 'Baca temizliği neden önemlidir?',
      answer: 'Kirli bacalar yangın riskini artırır, zehirli gaz birikimine neden olur ve ısınma verimliliğini düşürür. Düzenli temizlik hem güvenlik hem de tasarruf sağlar.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Baca Temizliği Hizmeti
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Ev ve işletmeler için profesyonel baca temizliği ile yangın riskini azaltın
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display font-bold text-3xl text-dark-900 mb-6">
              Baca Temizliği Nedir ve Neden Önemlidir?
            </h2>
            <p className="text-dark-600 leading-relaxed mb-6">
              <strong>Baca temizliği</strong>, bacalarda biriken kurum, is ve diğer yanma artıklarının profesyonel ekipmanlarla temizlenmesi işlemidir. İpek Yangın Söndürme olarak, ev ve işletmeler için güvenli ve etkili <strong>baca temizliği hizmeti</strong> sunuyoruz.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Düzenli baca temizliği, yangın riskini önemli ölçüde azaltır, zehirli gaz birikimine engel olur ve ısınma sistemlerinin verimli çalışmasını sağlar. Özellikle kış aylarında yoğun kullanılan bacaların temizliği hayati önem taşır.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4 mt-12">
              Baca Temizliği Süreci
            </h3>
            <div className="space-y-6 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Ön İnceleme</h4>
                  <p className="text-dark-600">Bacanın durumu, tipi ve kirliliği değerlendirilir. Güvenlik önlemleri alınır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Koruma Önlemleri</h4>
                  <p className="text-dark-600">Çalışma alanı örtülerle korunur, kirlilik yayılması önlenir.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Mekanik Temizlik</h4>
                  <p className="text-dark-600">Özel fırçalar ve ekipmanlarla baca içi detaylı şekilde temizlenir.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  4
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Kurum ve İs Temizliği</h4>
                  <p className="text-dark-600">Biriken tüm kurum, is ve yanma artıkları güvenli şekilde uzaklaştırılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  5
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Kontrol ve Test</h4>
                  <p className="text-dark-600">Temizlik sonrası baca çekişi kontrol edilir, gerekli testler yapılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  6
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Temizlik ve Raporlama</h4>
                  <p className="text-dark-600">Çalışma alanı temizlenir, hizmet raporu teslim edilir.</p>
                </div>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Baca Temizliği Neden Gereklidir?
            </h3>
            <ul className="list-disc list-inside space-y-3 text-dark-600 mb-8">
              <li><strong>Yangın Riski:</strong> Biriken kurum ve is tutuşarak baca yangınına neden olabilir</li>
              <li><strong>Zehirlenme Tehlikesi:</strong> Tıkalı bacalar karbonmonoksit birikimine yol açar</li>
              <li><strong>Verimlilik Kaybı:</strong> Kirli bacalar ısınma sisteminin verimliliğini düşürür</li>
              <li><strong>Yasal Zorunluluk:</strong> Bazı bölgelerde düzenli baca temizliği zorunludur</li>
              <li><strong>Sigorta Gerekliliği:</strong> Sigorta şirketleri baca temizliği belgesi talep edebilir</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Hangi Bacaların Temizliğini Yapıyoruz?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Soba Bacaları</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Şömine Bacaları</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Kalorifer Bacaları</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Endüstriyel Bacalar</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Restoran Bacaları</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Fırın Bacaları</p>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Kimler İçin Uygun?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-dark-600 mb-8">
              <li>Müstakil evler ve villalar</li>
              <li>Apartman ve site yönetimleri</li>
              <li>Restoranlar ve kafeler</li>
              <li>Oteller ve pansiyonlar</li>
              <li>Fabrikalar ve üretim tesisleri</li>
              <li>Fırınlar ve pastaneler</li>
              <li>Hamamlar ve saunalar</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Servis Bölgelerimiz
            </h3>
            <p className="text-dark-600 leading-relaxed mb-8">
              [Şehir] ve tüm ilçelerinde <strong>baca temizliği hizmeti</strong> vermekteyiz. Ücretsiz keşif ve uygun fiyat garantisi sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Baca Temizliği Hizmetimizin Avantajları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Profesyonel Ekipman</h3>
              <p className="text-dark-600 text-sm">Modern ve güvenli temizlik ekipmanları</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Güvenli Çalışma</h3>
              <p className="text-dark-600 text-sm">Tüm güvenlik önlemleri alınarak hizmet</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Deneyimli Ekip</h3>
              <p className="text-dark-600 text-sm">Uzman ve tecrübeli teknisyenlerimiz</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Belgelendirme</h3>
              <p className="text-dark-600 text-sm">Hizmet sonrası detaylı rapor</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Sık Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-dark-50 rounded-lg p-6 border-l-4 border-primary-600">
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Baca Temizliği İçin Hemen Arayın
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Ücretsiz keşif ve uygun fiyat garantisi ile profesyonel baca temizliği hizmeti
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ChimneyCleaningPage;
